<template>
    <div class="mainScreen">
        <div class="homeTab">
            <btn-groups :currentBtnType="0" @switchType="switchType"></btn-groups>
            <div class="homeTitle">伽利略数字驾驶舱</div>
            <div class="auxiliaryScreen clearfix">
                <i class="el-icon-s-operation closeBtn" @click="goBack"></i>
                <!-- @click="msgPropus" -->
                <!-- , msgHot: msgSum > 0 -->
                <div v-if="0" :class="{ msgIcon: 1, fr: 1 }"></div>
                <div class="timeContainer fr">
                    <p class="time">{{ currentTime | formatTime }}</p>
                    <p class="date">{{ currentTime | formatDate }}</p>
                </div>
                <div class="msg-table clearfix" v-if="msgShowFlag">
                    <div class="fugai"></div>
                    <div class="msgList fl" v-show="msgTypeClickShow">
                        <i class="closeBtn el-icon-circle-close" @click="msgTypeClickShow = false"></i>
                        <div class="cover"></div>
                        <el-row class="tableHeader">
                            <!-- <el-col :span="6">车辆离线告警</el-col> -->
                            <el-col :span="5">车牌号</el-col>
                            <el-col :span="8">告警时间</el-col>
                            <el-col :span="10">所属公司</el-col>
                        </el-row>
                        <div class="bodyBox">
                            <el-row class="tableBody" v-for="(item, index) in msgData" :key="index">
                                <!-- <el-col :span="6">{{ item.name0 }}</el-col> -->
                                <el-col :span="5">{{ item.plateNo }}</el-col>
                                <el-col :span="8">{{ item.startTime }}</el-col>
                                <el-col :span="10">
                                    <overflow-txt :txt="item.companyName"></overflow-txt>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div class="typeUl fr">
                        <li :class="{ activeLi: activeMsgTypeIndex == index }" v-for="(item, index) in msgTypeData" :key="index" @click="switchMsgData(item.value, index)">{{ item.label }}</li>
                    </div>
                </div>
                <!-- <div class="dimension">统计周期【昨天】</div> -->
            </div>
            <i class="close_btn el-icon-circle-close" v-show="0" @click="goBack"></i>
        </div>
        <div class="border-left"></div>
        <div class="border-right"></div>
        <div class="border-bottom"></div>
        <!-- 图表 -->
        <div class="charts-container">
            <div class="left-screen screenBox">
                <!-- 设备总览-->
                <div class="deviceOverview">
                    <!-- 总览1 -->
                    <div :class="`chartBox overview${index + 1}`" v-for="(item, index) in deviceTypeAnalysis" :key="index">
                        <div class="borderTop">{{ deviceeTypeObj[index] }}</div>
                        <div class="displayArea">
                            <div class="dashboard">
                                <div class="dashIcon">
                                    <img src="../../../public/images/home/indicator0.png" />
                                    <div class="titleBox autoP">
                                        <div class="dashTitle">{{ String(item.vehicleNum) == 'null' ? '0' : item.vehicleNum }}</div>
                                        <div class="dashSubTitle">辆</div>
                                    </div>
                                </div>
                                <div class="dashBottom">车辆总数</div>
                            </div>
                            <div class="dashboard">
                                <div class="dashIcon">
                                    <img src="../../../public/images/home/indicator1.png" />
                                    <div class="titleBox autoP">
                                        <div class="dashTitle">{{ String(item.dayTripVehicleNum) == 'null' ? '0' : item.dayTripVehicleNum }}</div>
                                        <div class="dashSubTitle">辆</div>
                                    </div>
                                </div>
                                <div class="dashBottom">当日在线数</div>
                            </div>
                            <div class="dashboard">
                                <div class="dashIcon">
                                    <img src="../../../public/images/home/indicator2.png" />
                                    <div class="titleBox autoP">
                                        <div class="dashTitle" v-if="item.tmpStr">{{ String(item.tmpStr) == 'null' ? '0' : item.tmpStr }}<span>w</span></div>
                                        <div class="dashTitle" v-else>{{ String(item.totalDrivingDuration) == 'null' ? '0' : item.totalDrivingDuration }}</div>
                                        <div class="dashSubTitle">小时</div>
                                    </div>
                                </div>
                                <div class="dashBottom">总驾驶时长</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 左2-->
                <div class="chartBox left2">
                    <div class="borderTop">驾驶评分分布<span class="miniTitle">（昨天）</span></div>
                    <div class="displayArea leftChartLine" v-loading="leftChartsLoading0">
                        <div id="leftChartLine"></div>
                        <div class="remark" v-if="!leftChartsLoading0"><img src="../../../public/images/home/star.png" /><span>驾驶评分越高，驾驶行为越好</span></div>
                    </div>
                </div>
            </div>
            <div class="centerLayCol screenBox layCol" v-loading="mapHeatLoading" element-loading-text="加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <div class="centerTop">
                    <ul class="mapBtnGroups clearfix">
                        <li :class="{ activeLi: activeIndex == index }" v-for="(item, index) in btnData" :key="index" @click="mapBtnClick(index, item)">{{ item.label }}</li>
                        <div class="remark"><img src="../../../public/images/home/star.png" /><span>热力图统计周期（上周）</span></div>
                    </ul>

                    <!-- 热力地图 -->
                    <china-map class="chinaMapName" ref="chinaMapRef" :chinaMapLoading="chinaMapLoading" :provinceValData="provinceValData" :cityData="currentTenantArea" :tooltipData="tooltipData" :heatCityData="heatCityData" :devicePixelRatio="devicePixelRatio"></china-map>
                </div>
                <div class="centerBottom">
                    <div class="chartBox left2">
                        <div class="borderTop clearfix">告警信息</div>
                        <div class="alarmList" v-loading="centerBottomChartsLoading">
                            <el-row class="listHeader">
                                <el-col :span="3">车牌号</el-col>
                                <el-col :span="8" :offset="1">运营公司</el-col>
                                <el-col :span="4" :offset="1">告警类型</el-col>
                                <el-col :span="6" :offset="1">告警时间</el-col>
                            </el-row>
                            <div class="bodyBox alarmBody" @mouseenter="clearAlarmTimer" @mouseleave="startAlarmTimer">
                                <template v-for="(item, index) in alarmData">
                                    <div class="alarmRow" :key="index" @click="redirectDetail(item, 3)">
                                        <!-- , activeRow: index == 1 && alarmActiveFlag -->
                                        <el-row :class="{ listBody: 1 }" :key="index">
                                            <el-col :span="3">{{ item.plateNo }}</el-col>
                                            <el-col :span="8" :offset="1">{{ item.companyName ? item.companyName : '' }}</el-col>
                                            <el-col :span="4" :offset="1" :style="{ color: alarmColor[item.type] }">
                                                <div :class="{ alarmImg: 1, [`alarmImg${item.type}`]: 1 }"></div>
                                                <span>{{ item.tmpAlarmTypeStr ? item.tmpAlarmTypeStr : '' }}</span>
                                            </el-col>
                                            <el-col :span="6" :offset="1">{{ item.alarmTime ? item.alarmTime : '' }}</el-col>
                                        </el-row>
                                    </div>
                                </template>
                            </div>
                            <div v-if="alarmData.length == 0 && !centerBottomChartsLoading" class="null_data_chart">暂无数据</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-screen screenBox">
                <!-- 右1 -->
                <div :class="{ chartBox: 1, filterContainer: msgShowFlag }">
                    <div class="borderTop">驾驶评分前三&后三城市<span class="miniTitle">（昨天）</span></div>
                    <div class="displayArea" v-loading="rightChartsLoading0">
                        <div class="ranking-box">
                            <div class="top">
                                <div class="randkingItem second">
                                    <div class="cityNum">{{ randkingData[1] && randkingData[1].drivingScore != null ? randkingData[1].drivingScore : '--' }}</div>
                                    <div class="cityName" v-if="randkingData[1] && randkingData[1].cityName.length < 5">{{ randkingData[1] && randkingData[1].cityName != null ? randkingData[1].cityName : '--' }}</div>
                                    <overflow-txt class="cityName" :txt="randkingData[1] && randkingData[1].cityName != null ? randkingData[1].cityName : '--'" v-else></overflow-txt>
                                </div>
                                <div class="randkingItem first">
                                    <div class="cityNum">{{ randkingData[0] && randkingData[0].drivingScore != null ? randkingData[0].drivingScore : '--' }}</div>
                                    <div class="cityName" v-if="randkingData[0] && randkingData[0].cityName.length < 5">{{ randkingData[0] && randkingData[0].cityName != null ? randkingData[0].cityName : '--' }}</div>
                                    <overflow-txt class="cityName" :txt="randkingData[0] && randkingData[0].cityName != null ? randkingData[0].cityName : '--'" v-else></overflow-txt>
                                </div>
                                <div class="randkingItem third">
                                    <div class="cityNum">{{ randkingData[2] && randkingData[2].drivingScore != null ? randkingData[2].drivingScore : '--' }}</div>
                                    <div class="cityName" v-if="randkingData[2] && randkingData[2].cityName.length < 5">{{ randkingData[2] && randkingData[2].cityName != null ? randkingData[2].cityName : '--' }}</div>
                                    <overflow-txt class="cityName" :txt="randkingData[2] && randkingData[2].cityName != null ? randkingData[2].cityName : '--'" v-else></overflow-txt>
                                </div>
                            </div>
                            <div class="bottom">
                                <template v-for="(item, index) in randkingData">
                                    <el-row class="randingRow" :key="index" v-if="index > 2">
                                        <el-col :span="2" :offset="1" class="colRandking">后{{ index - 2 }}</el-col>
                                        <el-col :span="14" :offset="1" class="colName">{{ randkingData[8 - index].cityName ? randkingData[8 - index].cityName : '--' }}</el-col>
                                        <el-col :span="4" :offset="2" class="colNum">{{ randkingData[8 - index].drivingScore ? randkingData[8 - index].drivingScore : '--' }}</el-col>
                                    </el-row>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 右2 -->
                <div class="chartBox" v-loading="rightChartsLoading1">
                    <div class="borderTop">出行时段分布<span class="miniTitle">（近三天）</span></div>
                    <div class="displayArea timePeriod circleBox">
                        <div id="rightChartBar"></div>
                    </div>
                </div>
                <!-- 右3 -->
                <div class="chartBox" v-if="userInfoData.tenantId == 10004">
                    <template v-if="deviceTypeAnalysis[1].vehicleNum > 0">
                        <div class="borderTop">事故车辆清单</div>
                        <div class="displayArea drivingBox" v-loading="rightChartsLoading2">
                            <div class="vehicleList">
                                <div class="buttonGroups">
                                    <div :class="{ btn: 1, activeBtn: btnIndex == index }" v-for="(item, index) in carBtnData" :key="index" @click="switchBtnType(index)">{{ item }}</div>
                                </div>
                                <div class="list">
                                    <el-row class="listHeader">
                                        <el-col :span="6">车队</el-col>
                                        <el-col :span="5" :offset="2">车牌号</el-col>
                                        <el-col :span="9" :offset="1">出险时间</el-col>
                                    </el-row>
                                    <div class="bodyBox" @mouseenter="clearAccidentTimer" @mouseleave="startAccidentTimer">
                                        <template v-for="(item, index) in vehicleData">
                                            <div :key="index" @click="redirectDetail(item, 1)">
                                                <!-- , activeRow: index == 2 && accidentActiveFlag -->
                                                <el-row class="listBody" :class="{ listBody: 1 }" v-show="index < 5">
                                                    <el-col :span="6"> <overflow-txt :txt="item.subTenantName"></overflow-txt></el-col>
                                                    <el-col :span="5" :offset="2">{{ item.plateNo }}</el-col>
                                                    <el-col :span="9" :offset="1">{{ item.realAccidentTime }}</el-col>
                                                </el-row>
                                            </div>
                                        </template>
                                    </div>
                                    <div v-if="vehicleData.length == 0 && !rightChartsLoading2" class="null_data_chart">暂无数据</div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="borderTop">车辆平均百公里三急一超城市<span class="miniTitle">（前5）</span></div>
                        <div class="displayArea circleBox">
                            <div class="circle" v-for="(item, index) in cityTop5" :key="index">
                                <div class="cityName">{{ item.cityName }}</div>
                                <div class="cityNum">{{ item.threeUrgentOneOvertakingNum }}</div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="chartBox" v-else>
                    <template v-if="userInfoData.currentTenantId != 10064">
                        <div class="borderTop">异常停留车辆清单<span class="miniTitle">（近一周）</span></div>
                        <div class="displayArea drivingBox" v-loading="rightChartsLoading2">
                            <div class="vehicleList">
                                <div class="list">
                                    <el-row class="listHeader">
                                        <el-col :span="5">车牌号</el-col>
                                        <el-col :span="6">停留时长</el-col>
                                        <el-col :span="13" :offset="1">停留地点</el-col>
                                    </el-row>
                                    <div class="bodyBox" @mouseenter="clearAccidentTimer(2)" @mouseleave="startAccidentTimer(2)">
                                        <template v-for="(item, index) in errorAddressData">
                                            <el-tooltip class="item" :key="index" effect="dark" :content="item.errorAddress" placement="top">
                                                <div @click="redirectDetail(item, 2)">
                                                    <!-- , activeRow: index == 2 && accidentActiveFlag -->
                                                    <el-row class="listBody" :class="{ listBody: 1 }" v-show="index < 6">
                                                        <el-col :span="5">{{ item.platNo }}</el-col>
                                                        <el-col :span="6">{{ item.stayTimeMinutesStr }}</el-col>
                                                        <el-col :span="13" :offset="1" style="overflow: hidden"><overflow-txt :txt="item.simpleErrorAddress"></overflow-txt></el-col>
                                                    </el-row>
                                                </div>
                                            </el-tooltip>
                                        </template>
                                    </div>
                                    <div v-if="errorAddressData.length == 0 && !rightChartsLoading2" class="null_data_chart">暂无数据</div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- 庆长风 10064 -->
                    <template v-else>
                        <div class="borderTop">车辆平均百公里三急一超城市<span class="miniTitle">（前5）</span></div>
                        <div class="displayArea circleBox">
                            <div class="circle" v-for="(item, index) in cityTop5" :key="index">
                                <div class="cityName">{{ item.cityName }}</div>
                                <div class="cityNum">{{ item.threeUrgentOneOvertakingNum }}</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import ChinaMap from '@/components/ChinaMap.vue';
import BtnGroups from '@/components/largeScreen/btnGroups.vue';
const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
const remToPx = (rem) => rem * rootFontSize;
export default {
    name: 'MainScreen',
    components: {
        ChinaMap,
        BtnGroups
    },
    data() {
        return {
            alarmActiveFlag: true,
            accidentActiveFlag: true,
            leftCharts2: null,
            leftChartsLoading0: false,
            rightChartsLoading0: false,
            rightChartsLoading1: false,
            rightChartsLoading2: false,
            centerBottomChartsLoading: false,
            chinaMapLoading: false,
            mapHeatLoading: false,
            devicePixelRatio: 1,
            currentTime: new Date(),
            timer: null,
            chartRight0: null,
            chartRight1: null,
            chartRight1Options: null,
            drivingDurationHours: [],
            msgShowFlag: false,
            msgData: [],
            cityTop5: [],
            msgTypeData: [
                { label: '镜头遮挡', value: 'lensOcclusion' },
                { label: '疲劳驾驶', value: 'fatigueDriving' },
                { label: '前向碰撞', value: 'forwardCollision' }
            ],
            activeMsgTypeIndex: null,
            msgSum: 0,
            heatMapDataType: 1, // 1:行程数 2:驾驶里程 3:驾驶时长
            btnData: [
                { label: '行程数', value: 1, unit: '条' },
                { label: '驾驶里程', value: 2, unit: '公里' },
                { label: '驾驶时长', value: 3, unit: '小时' }
            ],
            tooltipData: {
                label: '',
                unit: ''
            },
            activeIndex: 0,
            heatCityData: {},
            provinceValData: {},
            deviceeTypeObj: {
                0: 'TD（OBD）',
                1: 'DV（双摄）',
                2: 'SV（单摄）'
            },
            deviceTypeAnalysis: [
                {
                    deviceType: 0,
                    vehicleNum: null,
                    totalMileage: null,
                    totalDrivingDuration: null
                },
                {
                    deviceType: 1,
                    vehicleNum: null,
                    totalMileage: null,
                    totalDrivingDuration: null
                },
                {
                    deviceType: 2,
                    vehicleNum: null,
                    totalMileage: null,
                    totalDrivingDuration: null
                }
            ],
            mapHandleEvents: null,
            msgTypeClickShow: false,
            alarmTypeData: {
                镜头遮挡: 1,
                疲劳驾驶报警: 2,
                前向碰撞报警: 3,
                拔出报警: 4
            },
            alarmTypeStr: {
                镜头遮挡: '镜头遮挡',
                疲劳驾驶报警: '疲劳驾驶',
                前向碰撞报警: '前向碰撞',
                拔出报警: '拔出报警'
            },
            alarmData: [],
            tmpAlarmData: [],
            alarmColor: {
                1: '#4AE1FF',
                2: '#FFD940',
                3: '#FF3434',
                4: '#D84AFF',
                5: '#A260EE'
            },
            carBtnData: ['近7天', '近30天'],
            btnIndex: 0,
            vehicleData: [],
            tmpVehicleData: [],
            randkingData: [],
            vehicleDeviceForm: {
                startTime: null,
                endTime: null
            },
            accidentTimer: null,
            alarmTimer: null,
            userInfoData: {},
            errorAddressData: []
        };
    },
    computed: {
        productTypeData() {
            let typeData = this.$store.state.common.productTypeData;
            return typeData;
        },
        currentTenantArea() {
            return this.$store.state.common.currentTenantAreaData;
        }
    },
    mounted() {
        this.switchBtnType(0);

        this.userInfoData = JSON.parse(localStorage.getItem('userInfo'));

        this.timer = setInterval(() => {
            this.currentTime = new Date();
        }, 1000);

        // window.addEventListener('resize', () => {
        //     this.devicePixelRatio = window.devicePixelRatio || 1;
        //     this.$nextTick(() => {
        //         this.chartRight0 && this.chartRight0.resize();
        //         this.leftCharts2 && this.leftCharts2.resize();
        //     });
        // });

        this.getUserMessageReminderAlarm();

        setTimeout(() => {
            this.mapBtnClick(0, this.btnData[0]);
        }, 1000);

        this.getDeviceTypeAnalysis();
        this.getDrivingScoreAnalysis();
        this.getDrivingScoreCityAnalysis();
        this.getThreeUrgentOneOvertakingCity();
        this.getDayDrivingHoursCity();
        this.getDrivingPeriodDistribution();
        this.getErrorAddressTrip();

        window.addEventListener('resize', this.resizeHandler);
    },
    filters: {
        // 日期过滤器（年-月-日）
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}.${month}.${day}`;
        },
        // 时间过滤器（时:分:秒）
        formatTime(date) {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${hours}:${minutes}:${seconds}`;
        }
    },
    beforeDestroy() {
        // 组件销毁前清除定时器，防止内存泄漏
        this.clearAccidentTimer();
    },
    methods: {
        switchType(type) {
            this.$emit('switchType', type);
        },
        resizeHandler() {
            setTimeout(() => {
                if (this.leftCharts2) {
                    this.leftCharts2.resize();
                }
                if (this.chartRight1) {
                    // 更新配置中的字号
                    // this.chartRight1Options.title.textStyle.fontSize = newRootFontSize * 0.16;
                    // this.chartRight1Options.legend.textStyle.fontSize = newRootFontSize * 0.14;
                    // this.chartRight1Options.xAxis.axisLabel.fontSize = newRootFontSize * 0.12;
                    // this.chartRight1Options.yAxis.axisLabel.fontSize = newRootFontSize * 0.12;
                    // this.chartRight1Options.series[0].label.fontSize = newRootFontSize * 0.1;
                    // this.chartRight1.setOption(this.chartRight1Options);
                    this.chartRight1.resize();
                }
            }, 400);
        },
        // 异常停留车辆清单
        getErrorAddressTrip() {
            this.$request({ method: 'post', url: '/report/api/iovLargeScreen/errorAddressTripReport', data: {} }).then((res) => {
                if (res.code == 200) {
                    this.errorAddressData = res.data;
                    this.errorAddressData.length > 6 && this.startAccidentTimer(2);
                }
            });
        },
        // 出行时段分布
        getDrivingPeriodDistribution() {
            this.$request({ method: 'post', url: '/report/api/iovLargeScreen/drivingPeriodDistribution', data: {} }).then((res) => {
                if (res.code == 200) {
                    let tmpData = Object.entries(res.data).map(([key, value]) => ({ key, value }));
                    let seriesData = tmpData.map((item) => item.value);

                    this.loadChartRight1(seriesData);
                }
            });
        },
        clearAlarmTimer() {
            if (this.alarmTimer) {
                this.alarmActiveFlag = false;
                clearInterval(this.alarmTimer);
                this.alarmTimer = null; // 重置定时器实例
            }
        },
        startAlarmTimer() {
            // 防止重复创建定时器
            if (!this.alarmTimer) {
                this.alarmActiveFlag = true;
                this.alarmTimer = setInterval(() => {
                    if (this.tmpAlarmData.length > 0) {
                        const first = this.tmpAlarmData.splice(0, 1);
                        this.alarmData.unshift(first[0]);
                    } else {
                        this.clearAlarmTimer();
                    }
                }, 3000);
            }
        },
        clearAccidentTimer() {
            if (this.accidentTimer) {
                this.accidentActiveFlag = false;
                clearInterval(this.accidentTimer);
                this.accidentTimer = null; // 重置定时器实例
            }
        },
        startAccidentTimer(type) {
            // 防止重复创建定时器
            if (!this.accidentTimer) {
                this.accidentActiveFlag = true;
                this.accidentTimer = setInterval(() => {
                    switch (type) {
                        case 1:
                            const first1 = this.tmpVehicleData.splice(0, 1);
                            this.vehicleData.unshift(first1[0]);

                            break;
                        case 2:
                            const first2 = this.errorAddressData.shift();
                            this.errorAddressData.unshift(first2);
                            break;
                        case 3:
                            const first3 = this.tmpVehicleData.splice(0, 1);
                            this.vehicleData.unshift(first3[0]);
                            break;
                    }
                }, 2000);
            }
        },
        // 本周0、本月1
        setTimePeriod(type) {
            // 格式化时间为 "yyyy-mm-dd HH:MM:SS"
            const formatDateTime = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需+1
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            };

            // 获取当前时间，并重置到当天 00:00:00（如果需要包含当前时间的时分秒，可删除这一步）
            const getStartOfDay = (date) => {
                const newDate = new Date(date);
                newDate.setHours(0, 0, 0, 0); // 重置时分秒为 00:00:00
                return newDate;
            };

            // 获取近7天时间范围
            const getLast7Days = () => {
                const now = new Date();
                const end = getStartOfDay(now); // 结束时间：今天 00:00:00（若需当前时间，直接用 now）
                const start = new Date(end.getTime() - 7 * 24 * 60 * 60 * 1000); // 7天前
                return {
                    startTime: formatDateTime(start),
                    endTime: formatDateTime(end)
                };
            };

            // 获取近30天时间范围
            const getLast30Days = () => {
                const now = new Date();
                const end = getStartOfDay(now); // 结束时间：今天 00:00:00（若需当前时间，直接用 now）
                const start = new Date(end.getTime() - 30 * 24 * 60 * 60 * 1000); // 30天前
                return {
                    startTime: formatDateTime(start),
                    endTime: formatDateTime(end)
                };
            };

            let timeData = {
                startTime: null,
                endTime: null
            };
            switch (type) {
                case 0:
                    timeData = getLast7Days();
                    break;
                case 1:
                    timeData = getLast30Days();
                    break;
            }

            return timeData;
        },
        getVehicleDeviceAccident(typeStr) {
            this.$request({ method: 'post', url: '/report/api/iovLargeScreen/vehicleDeviceAccident', data: this.vehicleDeviceForm }).then((res) => {
                if (res.code == 200) {
                    // this.vehicleData = res.data;
                    let msgData = res.data;

                    if (typeStr == 'add') {
                        this.tmpVehicleData = msgData;
                        this.tmpVehicleData.sort((a, b) => {
                            // 将字符串时间转换为 Date 对象的时间戳（毫秒）
                            const timeA = new Date(a.realAccidentTime).getTime();
                            const timeB = new Date(b.realAccidentTime).getTime();
                            return timeA - timeB; // 正序（从小到大）
                        });
                    } else {
                        // this.tmpVehicleData = msgData.splice(0, 3);
                        this.tmpVehicleData = msgData;
                        this.tmpVehicleData.sort((a, b) => {
                            // 将字符串时间转换为 Date 对象的时间戳（毫秒）
                            const timeA = new Date(a.realAccidentTime).getTime();
                            const timeB = new Date(b.realAccidentTime).getTime();
                            return timeA - timeB; // 正序（从小到大）
                        });

                        this.vehicleData = msgData;
                    }

                    if (this.tmpVehicleData.length > 0) {
                        this.startAccidentTimer(1);
                        setTimeout(() => {
                            this.getVehicleDeviceAccident('add');
                        }, 1000 * 40);
                    } else {
                        this.accidentActiveFlag = false;
                    }
                }
            });
        },
        redirectDetail(row, type) {
            let routeUrl = this.$router.resolve({
                path: '/analysis/trajectoryAnalysis',
                query: {
                    deviceType: type < 3 ? '0' : row.deviceType,
                    deviceNumber: row.deviceNumber,
                    rowStartTime: row.trip.startTime,
                    tripUuid: row.trip.tripUuid
                }
            });

            window.open(routeUrl.href, '_blank');
        },
        switchBtnType(index) {
            this.btnIndex = index;
            this.vehicleDeviceForm = this.setTimePeriod(index);
            this.getVehicleDeviceAccident();
        },
        getUserMessageReminderAlarm(typeStr) {
            this.centerBottomChartsLoading = true;
            this.$request({
                method: 'post',
                url: `/ubi/api/advanceAlarm/userMessageReminderAlarm?filterTime=${typeStr == 'add' ? this.alarmData[0].alarmTime : ''}`,
                data: {}
            }).then((res) => {
                this.centerBottomChartsLoading = false;
                if (res.code == 200) {
                    let msgData = res.data.alarmList;
                    this.msgSum = 0;

                    // 镜头遮挡1  疲劳驾驶报警2  前向碰撞报警3  拔出报警4
                    msgData.forEach((item) => {
                        item.type = this.alarmTypeData[item.alarmTypeStr];
                        item.tmpAlarmTypeStr = this.alarmTypeStr[item.alarmTypeStr];
                    });

                    for (const key in msgData) {
                        this.msgSum += msgData[key].length;
                    }

                    if (typeStr == 'add') {
                        this.tmpAlarmData = msgData;
                        this.tmpAlarmData.sort((a, b) => {
                            // 将字符串时间转换为 Date 对象的时间戳（毫秒）
                            const timeA = new Date(a.alarmTime).getTime();
                            const timeB = new Date(b.alarmTime).getTime();
                            return timeA - timeB; // 正序（从小到大）
                        });
                    } else {
                        this.tmpAlarmData = msgData.splice(0, 3);
                        this.tmpAlarmData.sort((a, b) => {
                            // 将字符串时间转换为 Date 对象的时间戳（毫秒）
                            const timeA = new Date(a.alarmTime).getTime();
                            const timeB = new Date(b.alarmTime).getTime();
                            return timeA - timeB; // 正序（从小到大）
                        });

                        this.alarmData = msgData;
                    }

                    if (this.tmpAlarmData.length > 0) {
                        this.startAlarmTimer();
                    }
                    setTimeout(() => {
                        this.getUserMessageReminderAlarm('add');
                    }, 1000 * 40);
                } else {
                    console.log('热力图获取失败');
                }
            });
        },
        switchMsgData(msgType, msgTypeIndex) {
            this.msgData = this.alarmData[msgType];
            this.activeMsgTypeIndex = msgTypeIndex;
            this.msgTypeClickShow = true;
        },
        msgPropus() {
            this.msgShowFlag = !this.msgShowFlag;
            this.msgTypeClickShow = false;
            this.$refs.chinaMapRef.setCityNameColor(this.msgShowFlag);
        },
        mapBtnClick(index, btnItem) {
            this.activeIndex = index;
            this.heatMapDataType = btnItem.value;
            this.tooltipData = {
                label: btnItem.label,
                unit: btnItem.unit
            };

            this.getHeatMap();
        },
        // 热力图
        getHeatMap() {
            this.mapHeatLoading = true;
            let tmpAreaCode = this.currentTenantArea.areaCode || null;

            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/heatMap',
                data: { heatMapDataType: this.heatMapDataType, areaCode: tmpAreaCode }
            }).then((res) => {
                this.mapHeatLoading = false;

                if (res.code == 200) {
                    // 处理成 {城市名: 热度值} 结构
                    this.heatCityData = {};
                    let resHeatData = res.data;

                    // 按省份分组，累加heatMapDataVal
                    // 城市code 区分全国/省   省heatCityData对应是市数据
                    const provinceAggregatedData = resHeatData.reduce((acc, city) => {
                        // 以省份名称作为分组键（也可用provinceCode确保唯一性）
                        const key = tmpAreaCode ? city.cityName : city.provinceName;

                        if (!acc[key]) {
                            // 若该省份首次出现，初始化数据
                            acc[key] = {
                                provinceCode: tmpAreaCode ? city.cityCode : city.provinceCode,
                                provinceName: tmpAreaCode ? city.cityName : city.provinceName,
                                totalHeatMapDataVal: 0, // 累加值初始化
                                cities: [] // 存储下属城市数据（可选）
                            };
                        }
                        // 累加当前城市的heatMapDataVal到省份总数值
                        acc[key].totalHeatMapDataVal += city.heatMapDataVal;
                        // 可选：存储下属城市数据（便于后续展示城市列表）
                        acc[key].cities.push(city);

                        return acc;
                    }, {});

                    // 转换为数组形式（便于在ECharts中使用）
                    const provinceList = Object.values(provinceAggregatedData);

                    this.provinceValData = {};
                    provinceList.forEach((item) => {
                        if (!this.provinceValData[item.provinceName]) {
                            this.provinceValData[item.provinceName] = {
                                provinceName: item.provinceName,
                                totalHeatMapDataVal: Number.isInteger(item.totalHeatMapDataVal) ? item.totalHeatMapDataVal : item.totalHeatMapDataVal.toFixed(2)
                            };
                        }
                    });

                    // 遍历所有城市数据
                    resHeatData.forEach((cityItem) => {
                        // 提取城市名作为键，heatMapVal作为值
                        this.heatCityData[tmpAreaCode ? cityItem.cityName : cityItem.provinceName] = cityItem.heatMapDataVal;
                    });
                } else {
                    console.log('热力图获取失败');
                }
            });
        },
        // 设备总览
        getDeviceTypeAnalysis() {
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/deviceTypeAnalysis',
                data: {}
            }).then((res) => {
                if (res.code == 200) {
                    // 执行处理
                    const processedData = this.processData(res.data);
                    // processedData[0].tmpStr = 719;
                    this.deviceTypeAnalysis = processedData;
                }
            });
        },
        // 处理数据的函数
        processData(arr) {
            return arr.map((item) => {
                // 复制原对象避免直接修改
                const newItem = { ...item };

                // 遍历所有字段
                for (const key in newItem) {
                    // 跳过vehicleNum字段
                    if (key == 'totalDrivingDuration') {
                        // 处理有值的数字字段（排除null/undefined）
                        if (newItem[key] !== null && newItem[key] !== undefined && typeof newItem[key] === 'number') {
                            if (newItem[key] >= 10000) {
                                newItem['tmpStr'] = newItem[key] / 10000;
                                newItem['tmpStr'] = newItem['tmpStr'].toFixed(2);
                            } else {
                                newItem[key] = newItem[key].toFixed(0);
                            }
                        }
                    }
                }

                return newItem;
            });
        },
        // 驾驶评分分布
        getDrivingScoreAnalysis() {
            this.leftChartsLoading0 = true;
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/drivingScoreAnalysis',
                data: {}
            }).then((res) => {
                this.leftChartsLoading0 = false;
                if (res.code == 200) {
                    let dataArr = res.data;

                    // 先按drivingScore从小到大排序
                    const sortedData = [...dataArr].sort((a, b) => a.drivingScore - b.drivingScore);

                    let optionData = {
                        scoreDist: {
                            // 找到medianFlag为true的项的drivingScore作为中位数
                            median: ((sortedData.find((item) => item.medianFlag) || {}).drivingScore) || 0,
                            // 提取所有drivingScore组成scores数组
                            scores: sortedData.map((item) => item.drivingScore),
                            // 提取所有vehicleNum组成nums数组
                            nums: sortedData.map((item) => item.vehicleNum)
                        }
                    };

                    this.loadChartsLeft2(optionData.scoreDist);
                }
            });
        },
        // 驾驶评分前三后三
        getDrivingScoreCityAnalysis() {
            this.rightChartsLoading0 = true;
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/drivingScoreCityAnalysis',
                data: {}
            }).then((res) => {
                this.rightChartsLoading0 = false;
                if (res.code == 200) {
                    let chartData = res.data;

                    // 按驾驶分数从高到低排序
                    const sortedData = [...chartData].sort((a, b) => b.drivingScore - a.drivingScore);

                    this.randkingData = sortedData;
                }
            });
        },
        // 车辆平均百公里三急一超
        getThreeUrgentOneOvertakingCity() {
            this.rightChartsLoading1 = true;
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/threeUrgentOneOvertakingCity',
                data: {}
            }).then((res) => {
                this.rightChartsLoading1 = false;
                if (res.code == 200) {
                    let sumData = [...res.data].sort((a, b) => b.threeUrgentOneOvertakingNum - a.threeUrgentOneOvertakingNum);
                    this.cityTop5 = sumData;
                }
            });
        },
        // 日平均驾驶时长
        getDayDrivingHoursCity() {
            this.rightChartsLoading2 = true;
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/dayDrivingHoursCity',
                data: {}
            }).then((res) => {
                this.rightChartsLoading2 = false;
                if (res.code == 200) {
                    this.drivingDurationHours = res.data;
                    this.drivingDurationHours.forEach((item) => {
                        item.ratio = item.dayDrivingHours / 24;
                    });
                }
            });
        },
        // 格式化日期为 yyyy.MM.dd HH:mm:ss
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        goBack() {
            this.$router.push({
                path: '/vehicle/vehicleManage'
            });
        },

        loadChartsLeft2(optionData) {
            let chartDom = document.getElementById('leftChartLine');
            let median = Math.round(optionData.median);
            this.leftCharts2 = echarts.init(chartDom, null, { renderer: 'svg' });
            let option = {
                xAxis: {
                    type: 'category',
                    name: '分',
                    nameTextStyle: {
                        color: '#B8D3F1',
                        fontSize: remToPx(0.14)
                    },
                    boundaryGap: false,
                    // splitNumber:5,
                    axisLabel: {
                        interval: 4,
                        fontSize: remToPx(0.11),
                        color: '#B8D3F1'
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            width: '2',
                            color: 'rgba(54, 153, 255, 0.5)'
                        }
                    },
                    data: optionData.scores
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        color: '#B8D3F1',
                        fontSize: remToPx(0.14)
                    },
                    name: '单位：辆',
                    nameTextStyle: {
                        color: '#B8D3F1',
                        fontSize: remToPx(0.14)
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            width: '2',
                            color: 'rgba(54, 153, 255, 0.5)'
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#2C4065',
                            width: 1.1,
                            type: 'solid'
                        }
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b0} 分: {c0} 辆车',
                    textStyle: {
                        color: '#fff',
                        fontSize: remToPx(0.14) // 将提示框内所有文字设置为白色
                    },
                    backgroundColor: 'rgba(8, 32, 69, 0.9)',
                    borderColor: '#1E90FF',
                    borderWidth: 1,
                    confine: true
                },
                grid: {
                    top: '34',
                    bottom: '15%',
                    left: '15%',
                    right: '15%'
                },
                series: [
                    {
                        data: optionData.nums,
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        lineStyle: {
                            width: 2,
                            color: '#1ED6FF'
                            // shadowColor: 'red',
                            // shadowBlur: 10
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgba(30,214,255,0.2)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(30,214,255,0.1)'
                                }
                            ])
                        },
                        markLine: {
                            symbol: 'circle',
                            label: {
                                show: true,
                                color: '#B8D3F1',
                                formatter: '中位{c}',
                                fontSize: remToPx(0.14)
                            },
                            symbolSize: 7,
                            lineStyle: {
                                type: 'dotted',
                                color: '#B8D3F1',
                                width: 2
                            },
                            data: [
                                {
                                    xAxis: median + ''
                                }
                            ]
                        }
                    }
                ]
            };

            this.leftCharts2.setOption(option);
        },
        loadChartRight0(xAxisData, seriesData) {
            const colorMap = {
                前三: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#D6D260' },
                    { offset: 1, color: '#3D3B02' }
                ]),
                后三: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#1978E5' },
                    { offset: 1, color: '#10274B' }
                ])
            };

            let chartDom = document.getElementById('rightChartLine');
            this.chartRight0 = echarts.init(chartDom, null, { renderer: 'svg' });
            let option = {
                textStyle: {
                    fontFamily: 'PingFang Regular'
                },
                legend: {
                    data: seriesData.map((res) => res.name),
                    bottom: 0,
                    left: 'center',
                    orient: 'horizontal',
                    itemWidth: 8,
                    itemHeight: 8,
                    textStyle: {
                        color: '#fff',
                        fontSize: 12
                    },
                    itemGap: 15
                },
                tooltip: {
                    trigger: 'axis',
                    textStyle: {
                        color: '#fff' // 将提示框内所有文字设置为白色
                    },
                    backgroundColor: 'rgba(8, 32, 69, 0.9)',
                    borderColor: '#1E90FF',
                    borderWidth: 1,
                    formatter: function (params) {
                        let curItem = params.find((item) => item.data > 0);
                        return `<div>${curItem.name}：${curItem.data}</div>`;
                    }
                },
                grid: {
                    top: '17%',
                    left: '12%',
                    bottom: '25%'
                },
                xAxis: {
                    data: xAxisData,
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10,
                        rotate: 30,
                        align: 'center',
                        verticalAlign: 'bottom'
                    },
                    zlevel: 2
                },
                yAxis: {
                    name: '',
                    axisLabel: {
                        color: '#fff'
                    },
                    nameTextStyle: {
                        color: '#fff'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#2C4065',
                            width: 1,
                            type: 'solid'
                        }
                    }
                },
                series: seriesData.map((s) => ({
                    type: 'bar',
                    itemStyle: {
                        borderRadius: [20, 20, 0, 0],
                        color: colorMap[s.name]
                    },
                    barMaxWidth: 7,
                    ...s
                }))
            };
            this.chartRight0.setOption(option);
        },
        loadChartRight1(seriesData) {
            let xAxisData = ['0-4时', '4-7时', '7-9时', '9-12时', '12-17时', '17-19时', '19-24时'];

            const colorMap = {
                驾驶数量: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#00D5FF' },
                    { offset: 1, color: '#10274B' }
                ]),
                驾驶占比: '#D6D260'
            };

            let chartDom = document.getElementById('rightChartBar');
            this.chartRight1 = echarts.init(chartDom, null, { renderer: 'svg' });
            let option = {
                textStyle: {
                    fontFamily: 'PingFang Regular'
                },
                legend: {
                    data: ['驾驶占比'],
                    bottom: 7,
                    left: 'center',
                    orient: 'horizontal',
                    itemWidth: 8,
                    itemHeight: 8,
                    textStyle: {
                        color: '#fff',
                        fontSize: remToPx(0.14)
                    },
                    itemGap: 15
                },
                tooltip: {
                    trigger: 'axis',
                    textStyle: {
                        color: '#fff',
                        fontSize: remToPx(0.14) // 将提示框内所有文字设置为白色
                    },
                    backgroundColor: 'rgba(8, 32, 69, 0.9)',
                    borderColor: '#1E90FF',
                    borderWidth: 1,
                    formatter: function (params) {
                        let curItem = params.find((item) => item.data);
                        if (curItem) {
                            return `<div>${curItem.name}：${curItem.data}</div>`;
                        } else {
                            return;
                        }
                    }
                },
                grid: {
                    top: '17%',
                    left: '12%',
                    bottom: '25%'
                },
                xAxis: {
                    data: xAxisData,
                    axisLabel: {
                        color: '#fff',
                        fontSize: remToPx(0.11),
                        align: 'center'
                    },
                    axisTick: {
                        interval: 0 // 强制显示所有刻度
                    },
                    boundaryGap: true
                },
                yAxis: {
                    name: '单位：%',
                    axisLabel: {
                        color: '#fff',
                        fontSize: remToPx(0.14)
                    },
                    nameTextStyle: {
                        color: '#fff',
                        fontSize: remToPx(0.14)
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#666e7d',
                            width: 1,
                            type: 'solid'
                        }
                    }
                },
                series: [
                    {
                        type: 'bar',
                        name: '驾驶占比',
                        itemStyle: {
                            borderRadius: [20, 20, 0, 0],
                            color: colorMap['驾驶数量']
                        },
                        label: {
                            show: true, // 显示标签
                            position: 'top', // 位置：顶部
                            color: '#fff', // 文字颜色
                            fontSize: remToPx(0.14), // 文字大小
                            formatter: function (params) {
                                // params.value 是当前柱子的数值
                                return params.value + '%';
                            }
                        },
                        barMaxWidth: 7,
                        data: seriesData
                    }
                ]
            };
            this.chartRight1.setOption(option);
            this.chartRight1Options = option;
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="less" scoped>
::-webkit-scrollbar {
    width: 2px; /* 纵向滚动条宽度 */
    height: 2px; /* 横向滚动条高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    background: #c1c1c1;
}

/* 滑块hover状态 */
::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* 滚动条边角 */
::-webkit-scrollbar-corner {
    background: transparent;
}
.mainScreen {
    .homeTab {
        width: 100%;
        height: 0.75rem;
        margin-bottom: 0.26rem;
        text-align: center;
        background: url(../../../public/images/home/topBgc.png) no-repeat;
        background-size: 101% 100%;
        background-position: center;
        letter-spacing: 2px;
        position: relative;

        .homeTitle {
            width: 7.05rem;
            line-height: 0.7rem;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-weight: 400;
            font-size: 0.4rem;
            font-family: YouSheBiaoTiHei;
            letter-spacing: 10px;
            text-shadow: 0px 2px 8px rgba(17, 20, 22, 0.31), 0px 0px 46px rgba(46, 174, 255, 0.63);
        }

        .auxiliaryScreen {
            width: 400px;
            height: 30px;
            // border-bottom: 1px solid red;
            position: absolute;
            top: 0.5rem;
            right: 0.47rem;
            z-index: 9;
            .closeBtn {
                font-size: 0.26rem;
                position: absolute;
                right: -0.13rem;
                cursor: pointer;
            }
            .msgIcon {
                width: 0.2rem;
                height: 0.24rem;
                background: url(../../../public/images/home/msg.png) no-repeat;
                background-size: 100% 100%;
                position: relative;
                cursor: pointer;
                margin-right: 30px;
            }
            .msgHot::before {
                content: '';
                display: inline-block;
                width: 7px;
                height: 7px;
                background: red;
                position: absolute;
                top: -1px;
                right: -2px;
                border-radius: 50%;
            }
            .msg-table {
                width: 620px;
                position: absolute;
                top: 30px;
                right: 0;
                margin-top: 5px;
                z-index: 9999;
                .fugai {
                    width: 200px;
                    height: 200px;
                    // border: 1px solid red;
                    position: absolute;
                    z-index: -1;
                    // background: rgba(65, 159, 255, 0.5);
                    // background: transparent;
                    filter: blur(2px);
                }
                .msgList {
                    width: 506px;
                    background: rgba(65, 159, 255, 0.2);
                    border: 1px solid #2d7cc6;
                    position: relative;
                    .closeBtn {
                        position: absolute;
                        right: 2px;
                        top: 2px;
                        color: #fff;
                        font-size: 24px;
                        cursor: pointer;
                        z-index: 120;
                    }
                    .cover {
                        width: 506px;
                        height: 140px;
                        position: absolute;
                    }
                    .tableHeader {
                        height: 32px;
                        line-height: 32px;
                        background: rgba(65, 159, 255, 0.3);
                    }
                    .bodyBox {
                        height: 130px;
                        overflow-y: auto;
                        .tableBody {
                            height: 32px;
                            line-height: 32px;
                        }
                    }
                }
                .typeUl {
                    width: 106px;
                    padding: 6px 8px;
                    background: rgba(65, 159, 255, 0.3);
                    border-radius: 4px;
                    border: 1px solid #2d7cc6;
                    li {
                        height: 30px;
                        line-height: 30px;
                        margin-bottom: 5px;
                        cursor: pointer;
                    }
                    li:hover {
                        background: linear-gradient(269deg, rgba(32, 160, 249, 0.3) 0%, rgba(32, 160, 249, 0.8) 50%, rgba(32, 160, 249, 0.3) 100%);
                        border-radius: 3px;
                    }
                    .activeLi {
                        background: linear-gradient(269deg, rgba(32, 160, 249, 0.3) 0%, rgba(32, 160, 249, 0.8) 50%, rgba(32, 160, 249, 0.3) 100%);
                        border-radius: 3px;
                    }
                    li:last-child {
                        margin-bottom: 0;
                    }
                }
            }
            .timeContainer {
                margin-right: 18px;
                position: relative;
                top: -0.05rem;
                text-align: right;
                color: #cdd6e3;
                font-family: AlibabaPuHuiTi3;
                font-size: 18px;
                .time {
                    font-size: 0.18rem;
                    font-weight: 400;
                    margin-bottom: 0.05rem;
                }
                .date {
                    font-size: 0.1rem;
                }
            }
            // .timeContainer::before {
            //     content: '';
            //     display: inline-block;
            //     width: 2px;
            //     height: 20px;
            //     background: red;
            //     position: absolute;
            //     right: -20px;
            //     top: 50%;
            //     transform: translateY(-50%);
            //     background: #9dc5e8;
            // }
            .dimension {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                font-size: 16px;
                right: 175px;
                color: #cdd6e3;

                // background: linear-gradient(to bottom, #fff, #8dbfee);
                // -webkit-background-clip: text;
                // background-clip: text;
                // color: transparent;
            }
            .dimension::before {
                content: '';
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #0f9efc;
                position: absolute;
                left: -20px;
                top: 50%;
                transform: translateY(-50%);
            }
            .dimension::after {
                content: '';
                display: inline-block;
                width: 2px;
                height: 20px;
                background: red;
                position: absolute;
                right: -10px;
                top: 50%;
                transform: translateY(-50%);
                background: #9dc5e8;
            }
        }

        .close_btn {
            position: absolute;
            right: 0px;
            top: 3px;
            font-size: 28px;
            color: #fff;
            cursor: pointer;
            z-index: 6;
        }
    }
    .border-left,
    .border-right {
        width: 0.35rem;
        height: 100vh;
        position: absolute;
        left: -4px;
        top: 0;
    }

    .border-left {
        background: url(../../../public/images/home/leftBgc.png) no-repeat;
        background-size: 105% 100%;
        z-index: -1;
    }
    .border-left::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 3.8%;
        background: #001834;
        position: absolute;
        right: 2px;
        top: 0;
    }
    .border-left::before {
        content: '';
        display: inline-block;
        width: 10px;
        height: 3.3%;
        background: #001834;
        position: absolute;
        right: 2px;
        top: 0;
    }

    .border-right {
        left: auto;
        right: -4px;
        background: url(../../../public/images/home/rightBgc.png) no-repeat;
        background-size: 105% 100%;
    }

    .border-bottom {
        width: 100%;
        height: 0.5rem;
        position: absolute;
        bottom: -4px;
        left: 0;
        background: url(../../../public/images/home/bottomBgc.png) no-repeat;
        background-size: 100.5% 100%;
        background-position: center;
    }

    .charts-container {
        width: 100%;
        display: flex;
        gap: 20px;
        padding-bottom: 20px;
        .deviceOverview {
            .chartBox {
                .displayArea {
                    display: flex;
                    gap: 0.3rem;
                    padding: 0 0.25rem;
                    padding-top: 0.02rem;
                    height: auto !important;
                    max-height: 140px;
                    .dashboard {
                        flex: 1;
                        min-width: 0.82rem;
                        height: 1.2rem;
                        margin-bottom: 12px;
                        .dashIcon {
                            width: 0.9rem;
                            height: 0.9rem;
                            position: relative;
                            img {
                                position: absolute;
                            }
                            .titleBox {
                                top: 56%;
                            }
                            .dashTitle,
                            .dashSubTitle {
                                text-align: center;
                            }
                            .dashTitle {
                                margin-bottom: 0.03rem;
                                font-family: AlibabaPuHuiTi3;
                                font-weight: normal;
                                font-size: 0.18rem;
                                span {
                                    font-size: 0.14rem;
                                }
                            }
                            .dashSubTitle {
                                font-family: PingFang SC;
                                font-weight: 400;
                                font-size: 0.12rem;
                                color: rgba(255, 255, 255, 0.4);
                            }
                        }
                        .dashBottom {
                            width: 100%;
                            height: 0.27rem;
                            text-align: center;
                            line-height: 0.27rem;
                            background: rgba(155, 213, 255, 0.15);
                            border-bottom: 2px solid #6698cc;
                            letter-spacing: 1.5px;
                            margin-top: 7px;
                            font-size: 0.12rem;
                        }
                    }
                }
            }
        }
        .screenBox {
            width: 4.5rem;

            .timePeriod {
                background: url(../../../public/images/home/chartBg.png) no-repeat !important;
                background-size: 100% 100% !important;
            }

            .ranking-box {
                height: 100%;
                .top {
                    position: relative;
                    height: 50%;
                    margin-bottom: 0.15rem;
                    .randkingItem {
                        width: 1.38rem;
                        height: 0.84rem;
                        position: absolute;
                        background: url(../../../public/images/home/other.png) no-repeat !important;
                        background-size: 100% 100% !important;
                        .cityNum,
                        .cityName {
                            position: absolute;
                            left: 50%;
                            transform: translateX(-50%);
                        }
                        .cityNum {
                            top: 0.23rem;
                            font-family: YouSheBiaoTiHei;
                            font-weight: 400;
                            font-size: 0.24rem;
                            background: linear-gradient(to bottom, #44ffff, #ffffff);
                            -webkit-background-clip: text;
                            background-clip: text;
                            color: transparent;
                        }
                        .cityName {
                            bottom: -0.2rem;
                            padding: 0.03rem 0.1rem;
                            font-size: 0.12rem;
                            background: linear-gradient(90deg, #003f61 0%, #0076b6 50%, #003f61 100%);
                        }
                    }
                    .first {
                        width: 1.64rem;
                        height: 1rem;
                        top: -10px;
                        left: 50%;
                        transform: translateX(-50%);
                        background: url(../../../public/images/home/first.png) no-repeat !important;
                        background-size: 100% 100% !important;
                        .cityNum {
                            background: linear-gradient(to bottom, #ffe436, #ffffff);
                            -webkit-background-clip: text;
                            background-clip: text;
                            color: transparent;
                            top: 0.29rem;
                        }
                    }
                    .second {
                        top: 10%;
                        left: -8px;
                    }
                    .third {
                        top: 13%;
                        right: -5px;
                    }
                }
                .bottom {
                    // position: relative;
                    // top: -97px;
                    .randingRow {
                        width: 100%;
                        height: 0.3rem;
                        background: radial-gradient(50% 50% at 50% 99%, rgba(55, 152, 241, 0.2) 0%, rgba(55, 152, 241, 0) 100%), rgba(11, 73, 130, 0.14);
                        border-radius: 3px;
                        margin-bottom: 4px;
                        border: 1px solid #235088;
                        overflow: hidden;
                        .el-col {
                            line-height: 0.3rem;
                        }
                        .colRandking {
                            width: 0.26rem;
                            height: 0.26rem;
                            line-height: 0.26rem;
                            text-align: center;
                            border-radius: 50%;
                            background: linear-gradient(to bottom, #172535 0%, #253346 100%);
                            border: 1px solid #6388b8;
                            font-weight: 400;
                            font-size: 0.13rem;
                            position: relative;
                            top: 50%;
                            transform: translateY(-50%);

                            font-family: YouSheBiaoTiHei;
                        }
                        .colName {
                            font-weight: 700;
                            font-size: 0.13rem;
                        }
                        .colNum {
                            font-weight: 400;
                            font-size: 0.18rem;
                            background: linear-gradient(to bottom, #44ffff, #ffffff);
                            -webkit-background-clip: text;
                            background-clip: text;
                            color: transparent;
                            font-family: YouSheBiaoTiHei;
                        }
                    }
                }
            }

            .vehicleList {
                .buttonGroups {
                    display: inline-block;
                    margin-bottom: 0.05rem;
                    margin-top: -0.1rem;
                    background: rgba(21, 77, 160, 0.2);
                    border-radius: 4px;
                    padding: 0 0.1rem;
                    .btn {
                        display: inline-block;
                        // width: 0.5rem;
                        height: 0.3rem;
                        line-height: 0.3rem;
                        text-align: center;
                        border-radius: 4px;
                        letter-spacing: 0.02rem;
                        cursor: pointer;
                        padding: 0rem 0.04rem;
                        font-size: 0.14rem;
                    }
                    .activeBtn {
                        background: #0aa7ff;
                    }
                }
                .list {
                    .listHeader {
                        height: 0.26rem !important;
                        line-height: 0.26rem;
                        background: rgba(14, 108, 184, 0.3);
                        padding: 10px 8px;
                        margin: 0 !important;
                    }
                    .listBody {
                        cursor: pointer;
                        height: 0.26rem !important;
                        line-height: 0.26rem !important;
                        font-size: 0.12rem;
                        margin: 0 !important;
                        padding: 0.1rem 0.08rem;
                        background: radial-gradient(50% 50% at 50% 99%, rgba(55, 152, 241, 0.2) 0%, rgba(55, 152, 241, 0) 100%), rgba(11, 73, 130, 0.14);
                    }
                    .listBody:hover {
                        // transform: scale(1.05);
                        // z-index: 10; /* 避免被遮挡 */
                        border: 1px solid #42a9ff;
                        background: linear-gradient(to bottom, #1e5f93 0%, #1a4d7e 50%, #1e5f93 100%);
                    }
                    .activeRow {
                        border: 1px solid #42a9ff;
                        background: linear-gradient(to bottom, #1e5f93 0%, #1a4d7e 50%, #1e5f93 100%);
                    }
                }
            }
        }
        .screenBox:nth-child(1) {
            padding-left: 0.4rem;
        }
        .screenBox:nth-child(2) {
            flex: 1;
            // width: calc(100% - 1950px) !important;
            // padding: 10px;
            height: calc(100vh - 1.6rem);
            height: calc(100vh - 3.4rem);
        }
        .screenBox:nth-child(3) {
            padding-right: 0.4rem;
            .filterContainer {
                filter: blur(2px);
            }
        }
        .screenBox {
            height: calc(100vh - 1.01rem);
            .chartBox {
                margin-bottom: 0.1rem;
                .borderTop {
                    height: 0.32rem;
                    padding-left: 0.41rem;
                    font-family: '江城斜黑体';
                    font-size: 0.18rem;
                    color: #fff;
                    text-align: left;
                    background: url(../../../public/images/home/borderTopBgc.png) no-repeat;
                    background-size: 105% 100%;
                    background-position: 47% 0%;
                }
                .displayArea {
                    height: 2.56rem;
                    margin-top: 2px;
                    background: radial-gradient(ellipse farthest-side at -400% -10%, rgba(99, 99, 99, 0.4), rgba(0, 0, 0, 0));
                    #rightChartLine,
                    #rightChartBar {
                        height: 100%;
                    }
                }
                .circleBox {
                    position: relative;
                    .circle {
                        position: absolute;
                        border-radius: 50%;
                        text-align: center;
                        animation: moveUpDown 2s ease-in-out infinite;
                        .cityName {
                            width: 100%;
                            text-align: center;
                            color: #fff;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            font-family: PingFang SC;
                            font-size: 13px;
                            letter-spacing: 2px;
                        }
                        .cityNum {
                            text-align: center;
                            background: linear-gradient(to bottom, #d6d260, #3d3b02);
                            -webkit-background-clip: text;
                            background-clip: text;
                            color: transparent;
                            display: inline-block;
                            height: 20px;
                            line-height: 20px;
                            font-family: DIN;
                            font-size: 0.16rem;
                            position: absolute;
                            bottom: 0.25rem;
                            left: 50%;
                            transform: translateX(-50%);
                        }
                    }

                    .circle:nth-child(1) {
                        width: 1.24rem;
                        height: 1.24rem;
                        line-height: 1.24rem;
                        left: 33%;
                        top: 20%;
                        animation-delay: 0s;
                        background: url(../../../public/images/home/circle1.png) no-repeat;
                        background-size: 155% 170%;
                        background-position: 53% 48%;
                    }
                    .circle:nth-child(2) {
                        width: 1.1rem;
                        height: 1.1rem;
                        line-height: 1.14rem;
                        // border: 1px solid blue;
                        left: 68%;
                        top: 10%;
                        animation-delay: 0.4s;
                        background: url(../../../public/images/home/circle2.png) no-repeat;
                        background-size: 164% 179%;
                        background-position: 53% 48%;
                        .cityName {
                            top: 53%;
                            transform: translate(-50%, -50%);
                        }
                        .cityNum {
                            background: linear-gradient(to bottom, #cedbef, #92b4dd);
                            -webkit-background-clip: text;
                            background-clip: text;
                            color: transparent;
                            bottom: 0.2rem;
                        }
                    }
                    .circle:nth-child(3) {
                        width: 1.04rem;
                        height: 1.04rem;
                        line-height: 1.04rem;
                        // border: 1px solid yellow;
                        left: 7%;
                        top: 50%;
                        animation-delay: 0.8s;
                        background: url(../../../public/images/home/circle3.png) no-repeat;
                        background-size: 174% 190%;
                        background-position: 53% 48%;
                        .cityName {
                            top: 53%;
                            transform: translate(-50%, -50%);
                        }
                        .cityNum {
                            background: linear-gradient(to bottom, #eed6c3, #d1af79);
                            -webkit-background-clip: text;
                            background-clip: text;
                            color: transparent;
                            bottom: 0.15rem;
                        }
                    }
                    .circle:nth-child(4) {
                        width: 0.86rem;
                        height: 0.86rem;
                        line-height: 0.86rem;
                        // border: 1px solid #9ecbff;
                        left: 7%;
                        top: 10%;
                        animation-delay: 1.2s;
                        background: url(../../../public/images/home/circle4.png) no-repeat;
                        background-size: 183% 199%;
                        background-position: 52% 48%;
                        .cityName {
                            top: 53%;
                            transform: translate(-50%, -50%);
                        }
                        .cityNum {
                            background: #97c7ff;
                            -webkit-background-clip: text;
                            background-clip: text;
                            color: transparent;
                            bottom: 0.1rem;
                        }
                    }
                    .circle:nth-child(5) {
                        width: 0.86rem;
                        height: 0.86rem;
                        line-height: 0.86rem;
                        // border: 1px solid #9ecbff;
                        left: 65%;
                        top: 60%;
                        animation-delay: 1.6s;
                        background: url(../../../public/images/home/circle5.png) no-repeat;
                        background-size: 183% 199%;
                        background-position: 52% 48%;
                        .cityName {
                            top: 53%;
                            transform: translate(-50%, -50%);
                        }
                        .cityNum {
                            background: #97c7ff;
                            -webkit-background-clip: text;
                            background-clip: text;
                            color: transparent;
                            bottom: 0.1rem;
                        }
                    }
                }
                .drivingBox {
                    overflow: hidden;
                    padding-top: 10px;
                    .el-row {
                        height: 0.2rem;
                        margin-bottom: 0.2rem;
                        display: flex;
                        align-items: center;
                        .el-col {
                            font-size: 0.12rem;
                            font-family: PingFang SC;

                            .medalHot {
                                width: 0.18rem;
                                height: 0.18rem;
                                line-height: 0.18rem;
                            }

                            /* 进度条容器 */
                            .progressContainer {
                                width: 100%; /* 容器宽度 */
                                height: 8px; /* 容器高度 */
                                background: rgba(255, 255, 255, 0.06);
                                border-radius: 10px; /* 圆角 */
                                overflow: hidden; /* 隐藏超出部分 */
                                box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3); /* 内部阴影 */

                                /* 进度条 */
                                .progressBar {
                                    height: 100%; /* 进度条高度 */
                                    background: linear-gradient(90deg, #10274b 0%, #00d5ff 100%);
                                    width: 0; /* 初始宽度为 0，通过 JavaScript 动态设置 */
                                    border-radius: 10px; /* 圆角 */
                                    transition: width 1s ease; /* 过渡动画 */
                                }
                            }
                        }
                        .fleetName {
                            font-family: PingFang Regular;
                            font-size: 0.14rem;
                            max-width: 0.99rem;
                        }
                        .fleetDuration {
                            font-family: DIN;
                            font-size: 12px;
                            color: #ffffff;
                        }
                    }
                    .el-row:first-child {
                        margin-top: 0.15rem;
                    }
                }
            }

            .left2 {
                // margin-top: 6.07rem;
                #leftChartLine {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .remark {
        position: relative;
        img {
            width: 0.13rem;
            height: 0.13rem;
            margin-right: 0.05rem;
            display: inline-block;
        }
        span {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            font-size: 0.12rem;
        }
    }
    .leftChartLine {
        .remark {
            margin-top: 0.07rem;
            margin-left: 0.4rem;
            font-size: 0.12rem;
        }
    }
}

.miniTitle {
    font-size: 10px;
    letter-spacing: 1px;
}

.centerLayCol {
    position: relative;
    .centerTop {
        position: relative;
        // 大屏
        // height: calc(100vh - 340px);
        // 小屏
        // height: calc(100vh - 3.8rem);
        height: calc(100% - 15px);
        overflow: hidden;
        border: 1px solid;
        // border-bottom: 0;
        border-image: linear-gradient(360deg, rgba(0, 145, 255, 0.2), rgba(0, 145, 255, 0.6), rgba(0, 145, 255, 0.2)) 1 1;

        .mapBtnGroups {
            margin-left: 0.2rem;
            background: #0f3679;
            border-radius: 0.04rem;
            display: inline-block;
            position: absolute;
            top: 20px;
            z-index: 999;
            li {
                float: left;
                padding: 0.08rem;
                display: inline-block;
                cursor: pointer;
                border-radius: 0.04rem;
                letter-spacing: 0.02rem;
                font-size: 0.17rem;
            }
            li:hover {
                background: #0f9efc;
            }
            .activeLi {
                background: #0f9efc;
            }
            .remark {
                width: 100%;
                position: absolute;
                bottom: -0.3rem;
                left: 0;
                z-index: 99;
            }
        }
        .centerCharts {
            display: flex;
            justify-content: space-around;
            .centerCol0,
            .centerCol1 {
                margin-bottom: 0;
                .chartBox {
                    display: flex;
                    align-items: center;
                    height: calc(100% - 0.3rem);
                    overflow: hidden;
                    .chartCol {
                        height: 100%;
                        #centerChart0,
                        #centerChart1 {
                            height: 100%;
                        }
                    }
                    .wrapChart {
                        min-height: 0px;
                    }
                }
            }
            .centerChart1 {
                margin-bottom: 0;
            }
        }
    }
    .centerBottom {
        width: calc(100% + 1px);
        position: absolute;
        // bottom: -2.2rem;
        min-height: 1.85rem;

        .borderTop {
            padding-left: 50px !important;
            background: url(../../../public/images/home/centerBottomBgc.png) no-repeat !important;

            background-size: 110% 100% !important;
            background-position: -20px 0% !important;
            // 大屏
            // background-size: 110% 100% !important;
            // background-position: -30px 0% !important;
        }
        .alarmList {
            min-height: 150px;
            box-sizing: border-box;
            position: relative;
            .listHeader {
                height: 0.26rem !important;
                line-height: 0.26rem;
                background: rgba(14, 108, 184, 0.3);
                padding: 0rem 0.08rem;
                margin: 0 !important;
            }
            .alarmBody {
                width: 100%;
                height: 1.58rem;
                // border-bottom: 1px solid red;
                overflow: auto;
                position: absolute;
                left: 0;
                .alarmRow {
                    cursor: pointer;
                    height: 0.26rem !important;
                    line-height: 0.26rem !important;
                    font-size: 0.12rem;
                    margin: 0 !important;
                    padding: 0.1rem 0.08rem;
                }
            }
            .listBody {
                cursor: pointer;
                height: 0.26rem !important;
                line-height: 0.26rem !important;
                font-size: 0.12rem;
                margin: 0 !important;
                padding: 0rem 0.08rem;
                // transition: all 0.3s ease;
                overflow: hidden;
                background: radial-gradient(50% 50% at 50% 99%, rgba(55, 152, 241, 0.2) 0%, rgba(55, 152, 241, 0) 100%), rgba(11, 73, 130, 0.14);
                .alarmImg {
                    display: inline-block;
                    width: 0.16rem;
                    height: 0.16rem;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    // 镜头遮挡
                    background: url(../../../public/images/home/type1.png) no-repeat;
                    background-size: 100% 100%;
                }
                .alarmImg2 {
                    // 疲劳驾驶
                    background: url(../../../public/images/home/type2.png) no-repeat;
                    background-size: 100% 100%;
                }
                .alarmImg3 {
                    // 前向碰撞
                    background: url(../../../public/images/home/type3.png) no-repeat;
                    background-size: 100% 100%;
                }
                .alarmImg4 {
                    // 异常停留
                    background: url(../../../public/images/home/type4.png) no-repeat;
                    background-size: 100% 100%;
                }
                .alarmImg5 {
                    // 异常停留
                    background: url(../../../public/images/home/type5.png) no-repeat;
                    background-size: 100% 100%;
                }
                .alarmImg6 {
                    // 驶入
                    background: url(../../../public/images/home/type6.png) no-repeat;
                    background-size: 100% 100%;
                }
                .alarmImg7 {
                    // 插入
                    background: url(../../../public/images/home/type7.png) no-repeat;
                    background-size: 100% 100%;
                }
                span {
                    margin-left: 26px;
                }
            }
            .listBody:hover {
                // transform: scale(1.05);
                // z-index: 10; /* 避免被遮挡 */
                border: 1px solid #42a9ff;
                background: linear-gradient(to bottom, #1e5f93 0%, #1a4d7e 50%, #1e5f93 100%);
            }
            .listBody:nth-child(4) {
                position: relative;
                // left: -1px;
            }
            .activeRow {
                border: 1px solid #42a9ff;
                background: linear-gradient(to bottom, #1e5f93 0%, #1a4d7e 50%, #1e5f93 100%);
            }
        }
    }
}
/* 定义上下运动的动画 */
@keyframes moveUpDown {
    0%,
    100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-6px); /* 向上移动的距离 */
    }
}

.medalHot {
    width: 0.24rem;
    height: 0.24rem;
    line-height: 0.24rem;
    text-align: center;
}
.medalHot1 {
    background: url(../../../public/images/home/d1.png) no-repeat;
    background-size: 100% 100%;
}
.medalHot2 {
    background: url(../../../public/images/home/d2.png) no-repeat;
    background-size: 100% 100%;
}
.medalHot3 {
    background: url(../../../public/images/home/d3.png) no-repeat;
    background-size: 100% 100%;
}
.medalHot4 {
    background: url(../../../public/images/home/d4.png) no-repeat;
    background-size: 100% 100%;
}
.medalHot5 {
    background: url(../../../public/images/home/d4.png) no-repeat;
    background-size: 100% 100%;
}

/* 去除加载遮罩的白色背景 */
/deep/ .el-loading-mask {
    background-color: transparent !important; /* 透明背景 */
}

/* 修改加载圆圈的颜色 */
/deep/ .el-loading-spinner .path {
    stroke: #fff !important; /* 改为你需要的颜色，这里示例为 Element 主题蓝 */
}

@media (max-height: 710px) {
    .centerLayCol {
        .centerTop {
            height: calc(100% - 30px);
        }
        .centerBottom {
            bottom: -2.7rem;
        }
    }

    .mainScreen {
        .leftChartLine {
            .remark {
                margin-top: auto;
            }
        }
    }
}
</style>
